import React, { useEffect } from 'react'
// eslint-disable-next-line import/no-unresolved
import config from 'config'

export default function ComponentTag(packageConfig, isDeprecated = false) {
  return function ComponentTagHoc(Component) {
    const displayName = Component.displayName || Component.name || 'Component'
    const componentWithHoc = React.forwardRef((props, ref) => {
      useEffect(() => {
        if (isDeprecated) {
          console.warn(
            `${packageConfig.name} is deprecated and should be replaced. Please refer to the documentation for more information.`,
          )
        }
      }, [])

      const componentTag = config.displayComponentTags
        ? props.componentTag || {
            'data-component-name': packageConfig.name,
            'data-component-version': packageConfig.version,
            'data-component-deprecated': isDeprecated,
          }
        : {}

      return <Component {...props} componentTag={componentTag} ref={ref} />
    })

    componentWithHoc.displayName = displayName

    return componentWithHoc
  }
}
